import React from 'react';
import CheckCalendarContainer from '../../organisms/RTCC/checkCalendarContainer';
import CheckListPopupContainer from "../../organisms/RTCC/checkListPopupContainer";
import HeaderContainer from '../../organisms/RTCC/headerContainer';
import ReservationPopupContainer from "../../organisms/RTCC/reservationPopupContainer";
import RtccReservationContainer from '../../organisms/RTCC/rtccReservationContainer';
import { MemberShipCheck } from '../../../util/memberShipCheck';
import ScrollToTop from '../../atoms/RTCC/scrollToTop';


// import DetailConditionContainer from "../../organisms/RTCC/detailConditionContainer";

class RtccReservationTemplate extends React.Component {

    render() {
        return (
            <>
                <ScrollToTop />
                <MemberShipCheck outLine="none"/>
                <HeaderContainer
                    Label categoryLabel1={"RTCC予約（旅行サービス）"}
                    categoryLabel2={"RTCC"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    path={"/reserve/top"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    tabIndex="17" />
                <ReservationPopupContainer
                    key={"reservationPopup"}
                    state={this.props.state}
                    setPopupMode={this.props.setPopupMode}
                    setPopupMessage={this.props.setPopupMessage}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                    setDisplaySwitchTab={this.props.setDisplaySwitchTab}
                    setSelectRecommendFlg={this.props.setSelectRecommendFlg}
                    onClickCountWindow={this.props.onClickCountWindow}
                    createAgeCountList={this.props.createAgeCountList} />
                <CheckListPopupContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
                    setSelectRecommendFlg={this.props.setSelectRecommendFlg} />
                <CheckCalendarContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    checkInFlg={this.props.state.checkInFlg}
                    checkOutFlg={this.props.state.checkOutFlg} />
                <RtccReservationContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    setBeforeAreaId={this.props.setBeforeAreaId}
                    setBeforeCountryId={this.props.setBeforeCountryId}
                    setPopupData={this.props.setPopupData}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    setDisplaySwitchTab={this.props.setDisplaySwitchTab}
                    setSelectRecommendFlg={this.props.setSelectRecommendFlg}
                    createAgeCountList={this.props.createAgeCountList}
                />

            </>
        )
    }
}
export default RtccReservationTemplate;